import { render } from "./PlayerSelectionModal.vue?vue&type=template&id=8ee914a2&scoped=true"
import script from "./PlayerSelectionModal.vue?vue&type=script&lang=js"
export * from "./PlayerSelectionModal.vue?vue&type=script&lang=js"

import "./PlayerSelectionModal.vue?vue&type=style&index=0&id=8ee914a2&scoped=true&lang=css"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ee914a2"]])

export default __exports__